// extracted by mini-css-extract-plugin
export default {"JoinButton":"button_JoinButton__H1gWv","small":"button_small__s9JYI"};